import React from 'react';

interface RenderIfPropsType {
  condition: boolean;
  children: React.ReactNode | string | HTMLElement;
}

const RenderIf: React.FC<RenderIfPropsType> = (props) => {
  const { condition, children } = props;

  return condition ? <>{children}</> : null;
};

export default RenderIf;
